import Accordion from 'accordion-js';

function init() {
	document.querySelectorAll('.js-accordion').forEach((el) => {
		const accordion = new Accordion(el, {
			duration: 400,
		});
		accordion.open(+el.dataset?.open);
	});
}

function resize() {
}

export default {
	init,
	resize,
};
